import { Controller } from "react-hook-form";
import { useIntl } from "react-intl";
// @material-ui/core components
import Box from "@material-ui/core/Box";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Rating from "@material-ui/lab/Rating";

import componentStylesGeneric from "assets/theme/views/admin/generic";
import { messages } from "resources/resources";

const useStylesGeneric = makeStyles(componentStylesGeneric);

export default function RatingField(props) {
  const intl = useIntl();
  const classes = useStylesGeneric();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <FormGroup 
      classes={{
        root: classes.formRatingInTableCell,
      }}
    >
      {props.isEditable ? (
        <>
          <Controller
            name={props.name}
            control={props.control}
            setValue={props.setValue}
            component={Box}
            defaultValue=""
            rules={{
              required: {
                value: props.isRequired,
                message: intl.formatMessage(messages.Message_Generic_MandatoryField),
              },
              validate: {
                isGreaterThanZero: (value) => {
                  if (!props.isRequired || value > 0) return true;
                  return (
                    intl.formatMessage(messages.Message_Generic_MandatoryField)
                  );
                },
              },
            }}
            render={({ field: { onChange, name, value } }) => (
              <Box style={{ maxWidth: "100%" }}>
                <Rating
                  name={name}
                  value={Number(value)}
                  onChange={onChange}
                  size={isSmDown ? "small" : "medium"}
                  style={
                    isSmDown
                      ? {
                          maxWidth: "100%",
                          display: "inline-flex",
                          flexWrap: "wrap",
                        }
                      : undefined
                  }
                />
              </Box>
            )}
          />

          {props.errors[props.name] !== undefined && (
            <FormHelperText
              component={Box}
              color={props.theme.palette.warning.main + "!important"}
            >
              {props.errors[props.name].message}
            </FormHelperText>
          )}
        </>
      ) : 
        <Box style={{ maxWidth: "100%" }}>
          <Rating
            name={props.name}
            value={Number(props.answerValue)}
            disabled
            size={isSmDown ? "small" : "medium"}
            style={
              isSmDown
                ? {
                    maxWidth: "100%",
                    display: "inline-flex",
                    flexWrap: "wrap",
                  }
                : undefined
            }
          />
        </Box>
      }
    </FormGroup>
  );
}
